import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import dayjs from "dayjs";
import { WishlistManagementForm } from "halifax";
import "./styles.scss";
import { trackEvent } from "../../../../api/v1/analytics/trackEvent";
import {
  FAVORITES_CREATE_LIST,
  FAVORITES_EDITED_LIST,
  FAVORITES_ENTRY,
  FavoritesEntryProperties,
  FavoritesListProperties,
} from "redmond";

export const FavoritesSection = () => {
  useEffect(() => {
    trackEvent({
      eventName: FAVORITES_ENTRY,
      properties: {
        entry_type: "profile",
      } as FavoritesEntryProperties,
    });
  }, []);

  const handleOnCreateWishlist = (wishlistId: string) => {
    trackEvent({
      eventName: FAVORITES_CREATE_LIST,
      properties: {
        favorites_id: wishlistId,
      } as FavoritesListProperties,
    });
  };

  const handleOnDeleteWishlist = (wishlistId: string) => {
    trackEvent({
      eventName: FAVORITES_EDITED_LIST,
      properties: {
        favorites_id: wishlistId,
        action: "delete",
      } as FavoritesListProperties,
    });
  };

  return (
    <Box className="favorites-section">
      <WishlistManagementForm
        stayDates={{
          fromDate: dayjs().add(2, "day").toDate(),
          untilDate: dayjs()
            .add(2 + 4, "day")
            .toDate(),
        }}
        onCreateWishlist={handleOnCreateWishlist}
        onDeleteWishlist={handleOnDeleteWishlist}
        guests={{
          adults: 2,
          children: [],
          pets: 0,
        }}
      />
    </Box>
  );
};
